import { ReactNode } from 'react';

import { cx } from 'class-variance-authority';

interface Corporate5050WrapperProps {
  children: ReactNode;
  className?: string;
}

function Corporate5050Wrapper({
  children,
  className,
}: Corporate5050WrapperProps) {
  return (
    <div
      className={cx(
        'max-w-7xl overflow-hidden rounded-2xl sm:mx-auto',
        className
      )}
    >
      {children}
    </div>
  );
}

export default Corporate5050Wrapper;
